import React from 'react'
import { connect } from 'react-redux'
import agent from '../agent'
import numberHelper from '../util/numberFormatter'
import Loading from './widgets/Loading'
import Header from './widgets/Header'
import TransactionList from './widgets/TransactionList'
import QRCode from './widgets/QRCode'
import {
  TRANSACTIONS_LOADED,
  TRANSACTIONS_UNLOADED
} from '../constants/actionTypes'
import { BASE_COIN_SYMBOL } from '../constants/config'

let transactionAdded = false

const mapStateToProps = state => ({
  ...state.common,
  baseAccount: state.common.baseAccount,
  recentTransactions: state.common.recentTransactions,
  newTransactionAdded: state.common.newTransactionAdded
})

const mapDispatchToProps = dispatch => ({
  onLoad: (payload) => {
    dispatch({ type: TRANSACTIONS_LOADED, payload })
  },
  onUnload: () =>
    dispatch({ type: TRANSACTIONS_UNLOADED }),
})
class Transactions extends React.Component {
  componentWillMount() {
      let payload = null
      if (this.props.baseAccount) {
        payload = agent.Common.getTransactions(this.props.baseAccount.external)
      }
      
      this.props.onLoad(payload)
  }
  componentDidUpdate() {
    
  }
  componentWillUpdate(prevProps, nextProps) {
    
  }
  componentWillUnmount() {
  }
  render() {
    // sort category a-z :: categories[i]
    // get products by category, sort by name a-z :: categories[i].products

    return (
      <div>
        <Header selected={'transactions'} />
        <div id="main"><div id="main-wrap">

          <div id="content">
            <h2>Transactions</h2>
            <TransactionList data={{recentTransactions: this.props.recentTransactions, newTransactionAdded: this.props.newTransactionAdded}} />
          </div>
        </div></div>
      </div>
    )
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Transactions)
